import { downloadOptionToContentType } from './utils';
export const downloadFile = (urlPath, nameToSaveAs, fileType) => {
  const contentType = downloadOptionToContentType[fileType];
  const preFlight = {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'Content-Type': contentType
    }
  };
  return fetch(urlPath, preFlight).then(response => {
    if (response.ok) {
      return response.blob();
    }
    throw response;
  }).then(blob => {
    const fileUrl = window.URL.createObjectURL(blob);

    // @ts-expect-error: Navigator type not defined?
    if (window.navigator.msSaveBlob) {
      // @ts-expect-error: Navigator type not defined?
      window.navigator.msSaveBlob(blob, nameToSaveAs);
      return;
    }
    const downloadLink = window.document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.setAttribute('download', nameToSaveAs);
    window.document.body.appendChild(downloadLink);
    downloadLink.click();
    window.document.body.removeChild(downloadLink);
  });
};